import { Injectable } from '@angular/core';
import { RocEducationLevelModel } from '@cpd-app/core-module/models';
import { Apollo, gql } from 'apollo-angular';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EducationLevelService {
  public constructor(private apollo: Apollo) {}

  public getEducationLevels(): Observable<Array<RocEducationLevelModel>> {
    return this.apollo
      .use('datastopInstitution')
      .query({
        query: GET_EDUCATION_LEVELS,
        variables: {}
      })
      .pipe(
        map(
          (res) =>
            (res.data as any)
              ?.educationLevelMapped as Array<RocEducationLevelModel>
        ),
        catchError(() => of([]))
      );
  }
}

export const GET_EDUCATION_LEVELS = gql`
  query GetEducationLevels {
    educationLevelMapped {
      vpEducationLevel: vpEducationLevelTypeId
      name: vpEducationLevelTypeName
      onetEducationLevels: onet
    }
  }
`;
